// ReadySlide — final slide. CTA dismisses the wizard and routes to the
// role-appropriate landing page.

import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { useOnboarding } from '../useOnboarding'
import SlideShell from './SlideShell'

const HOME_BY_ROLE: Record<string, string> = {
  CLIENT: '/cont',
  WORKER: '/worker',
  COMPANY: '/firma',
  ADMIN: '/admin',
  GLOBAL_ADMIN: '/admin',
}

const CTA_BY_ROLE: Record<string, { primary: string; href: string }> = {
  CLIENT: { primary: 'Rezervă primul serviciu', href: '/rezervare' },
  WORKER: { primary: 'Vezi joburile disponibile', href: '/worker/comenzi' },
  COMPANY: { primary: 'Mergi la dashboard', href: '/firma' },
  ADMIN: { primary: 'Mergi la dashboard', href: '/admin' },
  GLOBAL_ADMIN: { primary: 'Mergi la dashboard', href: '/admin' },
}

interface Props {
  progress: number
  onBack: () => void
}

export default function ReadySlide({ progress, onBack }: Props) {
  const { user } = useAuth()
  const navigate = useNavigate()
  const { complete } = useOnboarding()
  const role = (user?.role ?? 'CLIENT').toUpperCase()
  const home = HOME_BY_ROLE[role] ?? '/cont'
  const cta = CTA_BY_ROLE[role] ?? CTA_BY_ROLE.CLIENT

  const handlePrimary = () => {
    complete()
    navigate(cta.href)
  }

  const handleSecondary = () => {
    complete()
    navigate(home)
  }

  return (
    <SlideShell
      progress={progress}
      onBack={onBack}
      footer={
        <div className="flex flex-col gap-2">
          <button
            onClick={handlePrimary}
            className="w-full bg-blue-600 active:bg-blue-700 active:scale-[0.99] transition text-white text-base font-medium px-4 py-3.5 rounded-xl"
          >
            {cta.primary}
          </button>
          {cta.href !== home ? (
            <button
              onClick={handleSecondary}
              className="w-full text-gray-500 text-sm py-2"
            >
              Mai târziu
            </button>
          ) : null}
        </div>
      }
    >
      <div className="flex flex-col items-center text-center pt-16">
        <div className="w-20 h-20 rounded-3xl bg-emerald-100 flex items-center justify-center mb-6" aria-hidden="true">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Totul e gata!
        </h1>
        <p className="text-base text-gray-600 dark:text-gray-300 mt-4 max-w-sm">
          Bine ai venit pe Go2Fix. Hai să începem.
        </p>
      </div>
    </SlideShell>
  )
}
